import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import * as actions from '../actions'
import scrollIntoView from 'scroll-into-view-if-needed'
import { AppState } from '../reducers'
import { AppMode } from '../constants'
import { Product, buildProductImagesLinks } from '../services/assortment.service'

type PartProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
    & { article: Product, selected: boolean, expanded: boolean }

class Part extends React.Component<PartProps> {
    countInput: HTMLInputElement
    partRef: HTMLDivElement

    constructor(props) {
        super(props);
    }

    render() {
        const { article, expanded, appMode, onImageClick, onChange, onClick, unClick, order } = this.props

        const name = article.namePL

        const clickFn = () => {
            if (this.props.selected) {
                unClick();
            } else {
                onClick(article.id)
            }
        }

        const { listPath } = buildProductImagesLinks(article);

        return (
            <div className="kr-part">
                <div className={`kr-part-header ${expanded ? 'kr-part-header-selected' : ''}`} onClick={clickFn}>
                    <div>{article.nr}</div>
                    <div>{name}</div>
                    {appMode === AppMode.Order && (
                        <input
                            ref={node => { this.countInput = node }}
                            type="text"
                            className="kr-number"
                            style={(order[article.id] && order[article.id] > 0) ? {color: '#2B2B2B'} : {}}
                            value={order[article.id] ?? 0}
                            min="0"
                            onFocus={event => event.target.select()}
                            onChange={event => onChange(article.id, event.target.value)}
                            onClick={e => {
                                e.preventDefault(); 
                                e.stopPropagation();
                                onClick(article.id);
                            }}
                        />
                    )}
                </div>
                <div ref={node => { this.partRef = node }} className={`kr-part-body`} style={{ height: '0px' }}>
                    <img className="kr-part-image" onClick={() => onImageClick(this.props.listImages.get(listPath))} src={this.props.listImages.get(listPath)?.toString() ?? ''} alt="" />
                </div>
            </div>
        )
    }

    componentDidUpdate() {
        if (this.props.selected) {
            const height = getComputedStyle(this.partRef.querySelector('img')).width;
            scrollIntoView(ReactDOM.findDOMNode(this.partRef), {
                scrollMode: 'if-needed',
                block: 'end',
                inline: 'nearest'
            });
            this.partRef.animate([
                { height: height }
            ], {
                duration: 300,
                fill: 'forwards'
            }).addEventListener('finish', () => {
                scrollIntoView(ReactDOM.findDOMNode(this.partRef), {
                    scrollMode: 'if-needed',
                    block: 'end',
                    inline: 'nearest'
                });
            });
            if (this.props.appMode === AppMode.Order) {
                this.countInput.focus()
            }
        } else {
            this.partRef.animate([
                { height: '0px' }
            ], {
                duration: 300,
                fill: 'forwards'
            });
        }
    }
}

const mapStateToProps = (state: AppState) => ({
    appMode: state.config.appMode,
    lang: state.lang,
    listImages: state.listImages,
    order: state.order,
    filters: state.filters
})

const mapDispatchToProps = dispatch => ({
    onImageClick: (src) => {
        dispatch(actions.modal(src))
    },
    onChange: (id: number, value: string) => {
        const count = Number(value);
        if (isNaN(count)) {
            alert('Nieprawidłowa wartość.');
        } else {
            dispatch(actions.editOrder(id, count));
        }
    },
    onClick: (id) => {
        dispatch(actions.selectArticleAction(id))
        dispatch(actions.togglePartImage())
    },
    unClick: () => {
        dispatch(actions.selectArticleAction(null))
        dispatch(actions.togglePartImage())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Part)